export const PASSWORD_PATTERN = /^(?=.*[0-9]+.*)(?=.*[a-zA-Z]+.*)[0-9a-zA-Z]{6,}$/
export const PASSWORD_NON_SPACE = /^\S+$/i
